// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3YzS6","requiredAsterisk":"Info_requiredAsterisk__3Rx9f"};